import {
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
// import VWDropdown from "components/dropdown";
import { removeEmptyKeys } from "helper/encodeData";
import React, {
    useEffect,
    useState
} from "react";
import { connect } from "react-redux";
import {
    customerCreate,
    customerCreateErrorClear,
    // getUsersOption
} from "store/app/customer-management/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}

const CreateCustomer = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;

    const [customerData, setCustomerData] = useState();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        props.customerCreateErrorClear();
        setCustomerData();
        setErrors({});
    }, [open])

    //--------------------User---------------------------
    // const [usersOptions, setUsersOptions] = useState([]);

    // const loadUsersOption = (filter) => {
    //     return props.getUsersOption(filter)
    // }

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        let result = {};

        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            result = {
                isValid: !emailRegex.test(value),
                message: 'Enter valid email address',
            };
        }
        if (name === 'mobileNumber') {
            const contactNumberRegex = /^\d{10}$/;
            result = {
                isValid: !contactNumberRegex.test(value),
                message: 'Enter valid mobile number',
            };
        }

        setCustomerData({
            ...customerData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: result.isValid ? result.message : null,
        })
    }

    // const handleAssignedUsersSelect = (option, name) => {
    //     const optionArray = option?.map(field => field.value);
    //     setCustomerData({
    //         ...customerData,
    //         [name]: optionArray
    //     })
    // }

    const handleChangePassword = (e) => {
        e.preventDefault();

        const { customerName, email, mobileNumber } = customerData || {};
        const currentErrors = {};

        if (!customerName && !customerName?.trim()) {
            currentErrors.customerName = 'Customer name is required';
        }
        if (!email && !email?.trim()) {
            currentErrors.email = 'Email address is required';
        }
        if (errors && errors.email) {
            currentErrors.email = 'Enter valid email address';
        }
        if (!mobileNumber && !mobileNumber?.trim()) {
            currentErrors.mobileNumber = 'Mobile number is required';
        }
        if (errors && errors.mobileNumber) {
            currentErrors.mobileNumber = 'Enter valid mobile number';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.customerCreate(customerData, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Create Customer
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    label={<div >Customer Name <Required /></div>}
                                                    fullWidth
                                                    autoFocus
                                                    size="small"
                                                    name='customerName'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    error={errors?.customerName}
                                                    helperText={errors?.customerName}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label={<>Email Address<Required /></>}
                                                    fullWidth
                                                    size="small"
                                                    name='email'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    error={errors?.email}
                                                    helperText={errors?.email}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label={<>Mobile Number <Required /></>}
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='mobileNumber'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    error={errors?.mobileNumber}
                                                    helperText={errors?.mobileNumber}
                                                />
                                            </Grid>
                                            {/* <Grid item sx={{ width: "100%" }}>
                                                <VWDropdown
                                                    label="Assigned Users"
                                                    name="userIds"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadUsersOption}
                                                    onSelect={handleAssignedUsersSelect}
                                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    // selectedOption={filterData?.technicalmanageremail ? selectedManager : []}
                                                    options={usersOptions}
                                                    setOptions={setUsersOptions}
                                                />
                                            </Grid> */}
                                            <Grid item >
                                                <TextField
                                                    label={<>Address </>}
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    size="small"
                                                    name='address'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleChangePassword}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.customers.isCustomerCreatePending,
    errorMessage: state.customers.customerCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    customerCreate: (formData, filter, paginationData) => dispatch(customerCreate(formData, filter, paginationData)),
    customerCreateErrorClear: () => dispatch(customerCreateErrorClear()),
    //--------------------User---------------------------
    // getUsersOption: (filter) => dispatch(getUsersOption(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateCustomer);